export default __webpack_public_path__ + "static/media/freeCodeCamp.1f7e3c57.jpg";